import { Actor } from "../../action/Actor.js";
import { Transform } from "../../geom/Transform.js";
import { Calc } from "../../math/Calc.js";
import { VideoPlayer } from "../VideoPlayer.js";

export class VideoPlayerTimeline {
    public element: HTMLElement;

    private _actor: Actor;
    private _track: HTMLDivElement;
    private _buffer: HTMLDivElement;
    private _progress: HTMLDivElement;

    constructor(private _player: VideoPlayer) {
        this.element = document.createElement("div");
        this.element.className = "e5-video-player-timeline e5-hidden";
        this.element.innerHTML = `
            <div class="e5-video-player-timeline__track">
            <div class="e5-video-player-timeline__buffer"></div>
            <div class="e5-video-player-timeline__progress"></div>
            `;
        this._track = this.element.querySelector(".e5-video-player-timeline__track");
        this._buffer = this.element.querySelector(".e5-video-player-timeline__buffer");
        this._progress = this.element.querySelector(".e5-video-player-timeline__progress");

        var actor = new Actor(this.element, {
            preventDefault: true
        });
        this._actor = actor;

        var updateProgressPosition = (): void => {
            var local = Transform.toLocal(this.element, actor.pointer.x, actor.pointer.y);
            this._progress.style.width = (Calc.clamp(local.x / this.element.offsetWidth, 0, 1) * 100) + "%";
        };
        actor.onDown.add(updateProgressPosition);
        actor.onMove.add(updateProgressPosition);
        actor.onUp.add(() => {
            if (!this._player.video)
                return;
            var local = Transform.toLocal(this.element, actor.pointer.x, actor.pointer.y);
            var time = Calc.clamp(local.x / this.element.offsetWidth, 0, 1) * this._player.video.duration;
            this._player.video.seek(time);
        });

        this._player.onBufferChange.add(this.handleBufferChange, this);
        this._player.onTimeChange.add(this.handleTimeChange, this);

        this._player.onChangeVideo.add((video) => {
            var hidden = !Boolean(video);
            this.element.classList.toggle("e5-hidden", hidden);
            if (hidden)
                actor.cancel();
        });
    }

    private handleBufferChange(buffer: number): void {
        if (!this._player.video || !this._player.video.duration) {
            this._buffer.style.width = "0";
        } else {
            this._buffer.style.width = (buffer * 100) + "%";
        }
    }

    private handleTimeChange(time: number): void {
        if (this._actor.pointers.length > 0)
            return;

        if (!this._player.video || !this._player.video.duration) {
            this._progress.style.width = "0";
        } else {
            this._progress.style.width = ((this._player.video.time / this._player.video.duration) * 100) + "%";
        }
    }
}